import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';


@Injectable()
export class ProductCategoriesActions {

    static SET_ALL_CATEGORIES = '[ProductCategories]: Set all categories';
    static SET_TRAVELLER_CATEGORIES = '[ProductCategories]: Set traveller categories';
    static SET_FILTERED_TRAVELLER_CATEGORIES = '[ProductCategories]: Set filtered traveller categories';
    static SET_SELECTED_TRAVELLER_CATEGORY = '[ProductCategories]: Set selected traveller category';

    static SET_PRODUCT_CATEGORIES = '[ProductCategories]: Set product categories';
    static SET_FILTERED_PRODUCT_CATEGORIES = '[ProductCategories]: Set filtered product categories';
    static SET_SELECTED_PRODUCT_CATEGORY = '[ProductCategories]: Set selected product category';

    static CLEAR_PRODUCT_CATEGORIES = '[ProductCategories]: Clear product categories';

    // new stuff
    static FETCH_PRODUCT_CATEGORIES = '[Product Categories] Fetch All Product Categories';
    static FETCH_PRODUCT_CATEGORIES_SUCCESS = '[Product Categories] Fetch All Product Categories Success';
    static FETCH_PRODUCT_CATEGORIES_FAILED = '[Product Categories] Fetch All Product Categories Failed';

    static SET_SELECTED_CATEGORY_BY_TYPE = '[Product Categories]: Set Selected Category By Type';
    static RESET_CATEGORY_SELECTIONS = '[Product Category] Reset Category Selections';

    setAllCategories(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_ALL_CATEGORIES,
            payload: payload
        };
    }
    setFilteredTravellerCategories(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_FILTERED_TRAVELLER_CATEGORIES,
            payload: payload
        };
    }
    setSelectedTravellerCategory(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_SELECTED_TRAVELLER_CATEGORY,
            payload: payload
        };
    }


    setFilteredProductCategories(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_FILTERED_PRODUCT_CATEGORIES,
            payload: payload
        };
    }
    setSelectedProductCategory(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_SELECTED_PRODUCT_CATEGORY,
            payload: payload
        };
    }

    clearProductCategories(): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.CLEAR_PRODUCT_CATEGORIES
        };
    }


    fetchProductCategories(): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES,
        };
    }
    fetchProductCategoriesSuccess(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES_SUCCESS,
            payload: payload
        };
    }
    fetchProductCategoriesFailed(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES_FAILED,
            payload: payload
        };
    }

    setSelectedCategoryByType(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_SELECTED_CATEGORY_BY_TYPE,
            payload: payload
        };
    }

    setProductCategories(payload): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.SET_PRODUCT_CATEGORIES,
            payload: payload
        }
    }

    resetCategorySelections(): RidangoReduxAction {
        return {
            type: ProductCategoriesActions.RESET_CATEGORY_SELECTIONS,
        };
    }

}
